import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-toast-data-service',
	templateUrl:'./WaToastDataServicePage.html',
	styles: [],
	styleUrls:['./WaToastDataServicePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaToastDataServicePage
{
	mdContent_475 = `\`\`\`java
import com.jwebmp.webawesome.components.toast.WaToastDataService;
\`\`\``;
	mdContent_476 = `\`\`\`java
// In your component, inject the toast container
// and use WaToastItem to add notifications programmatically
\`\`\``;
}
